import { getMomentTimeToUTC } from "../time-manipulations";

export let mainUrl: string;
if (window.location.origin.includes('localhost:')) {
  mainUrl = 'https://api.aboba.studio/api';
} else if (window.location.origin.includes('aboba.studio')) {
  mainUrl = 'https://api.aboba.studio/api';
} else {
  mainUrl = 'https://api.bambook.place/api';
}
interface Error {
    error_text: string;
    error_code: string;
}

interface ReserveResponce {
    status: string;
    message: string;
    errors: Error[];
    payload: string;
}

interface RestaurantInfo {
    name: string;
    phone: string;
    color: string;
    timeZone: number;
    isAutoSelectTable: boolean;
    yandexMetricCounter: number;
}

interface ShowReserveInfo {
  name: string;
  address: string,
  time: string,
  status: string,
  guests: number,
  email: string,
  phone: string,
}

export interface calendarDays {
  day: number;
  isAvailable: boolean;
  timeSlots: string[];
}


export const createUserReservation = (
    restaurantId: number,
    name: string,
    phone: string,
    guests: number,
    date: string,
    time: string,
    note: string,
    dataProcessingAllowed: boolean
  ) => {
    return new Promise<ReserveResponce>((resolve, reject) => {
      fetch(mainUrl + '/Reservations/CreateUserReservation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          restaurantId: restaurantId,
          guestPhone: phone,
          guestName: name,
          guestCount: guests,
          reservedAtDateTime: getMomentTimeToUTC(date + 'T' + time + ':00').format("YYYY-MM-DDTHH:mm:ss"),
          note: note,
          userAgent: navigator.userAgent,
          dataProcessingAllowed: dataProcessingAllowed
        }),
      })
      .then((response) => {
        return response.json();
      })
        .then((data) => {
          if (data.status == 'Success') {
            console.log('resolve');
            resolve(data);
          } else {
            console.log('reject');
            reject(data);
          }
        })
        .catch((data) => {
          reject('data.statusText');
        });
    });
  };

  export const getTimeSlots = (date: string, restaurantId: number, isManagerReservation: boolean) => {
    return new Promise<string[]>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/GetTime?date=${date}&id=${restaurantId}&isManagerForm=${isManagerReservation}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  };

  export const getRestaurantInfo = (restaurantId: number) => {
    return new Promise<RestaurantInfo>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/GetRestaurantInfo?restaurantId=${restaurantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          if (response.status == 200) {
            resolve(response.json());
          }
        })
        .catch(() => {
          reject();
        });
    });
  };

  export const getShowReserveInfo = (reserveId: string) => {
    return new Promise<ShowReserveInfo>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/GetClientReservationInfo?reservationId=${reserveId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          if (response.status == 200) {
            resolve(response.json());
          }
        })
        .catch(() => {
          reject();
        });
    });
  };

  export const CancellReservation = (reserveId: string) => {
    return new Promise<void>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/CancellReservation?reservationId=${reserveId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          if (response.status == 200) {
            resolve();
          }
        })
        .catch(() => {
          reject();
        });
    });
  };
  
  export const SendReservationEmail = (reserveId: string, email: string) => {
    return new Promise<void>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/SendReservationEmail?reservationId=${reserveId}&email=${email}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          if (response.status == 200) {
            resolve();
          }
        })
        .catch(() => {
          reject();
        });
    });
  };
  
  export const getDaysSlots = (month: string | number, year: string | number, restaurantId: string | number) => {
    return new Promise<calendarDays[]>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/GetAvailableDays?month=${month}&year=${year}&restaurantId=${restaurantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  };

  export const getNewTimeSlots = (date: string, restaurantId: string | number) => {
    return new Promise<string[]>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/GetAvailableTimes?date=${date}&restaurantId=${restaurantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  };

  export const getGuestsSlots = (dateOfschedule: string, dateTime: string, restaurantId: string | number) => {
    return new Promise<number[]>((resolve, reject) => {
      fetch(mainUrl + `/Reservations/GetAvailableGuests?dateOfSchedule=${dateOfschedule}&dateTime=${dateTime}&restaurantId=${restaurantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  };
